import React from 'react';

import { Alert } from '@mantine/core';
import { IconAlertTriangle } from '@tabler/icons-react';

import { PackageType } from '../../../../../types';

interface IRenewalBillingAlertProps {
  packageType: PackageType;
}

const RenewalBillingAlert = ({ packageType }: IRenewalBillingAlertProps): JSX.Element => {
  return (
    <Alert
      icon={<IconAlertTriangle size='1rem' />}
      color='yellow'
      variant='light'
      style={{ marginBottom: '1rem' }}
    >
      {packageType === 'TIME_OR_CREDIT_BASED'
        ? 'This plan includes multiple installments. Renewal may happen before all payments are complete; ' +
          "remaining installments will still be collected on their original dates, alongside the new package's " +
          'payments.'
        : 'This plan includes multiple installments, keep in mind that renewal may happen before all payments are ' +
          'complete.'}
    </Alert>
  );
};

export default RenewalBillingAlert;
